/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ManagedByBackupServer } from './components';

export interface ProtectedDataManagedByBackupServerPageProps {
    currentPath?: string;
}

export const ProtectedDataManagedByBackupServerPage: React.FC<ProtectedDataManagedByBackupServerPageProps> = ({ currentPath }) => (
    <TabBarBodyLayout>
        <ManagedByBackupServer stateId={currentPath} />
    </TabBarBodyLayout>
);
